export default "__VITE_ASSET__9a56f391__"